"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const DateFormat = (props) => {
    const { value, format: formatStr, prefix } = props;
    const [formattedDate, setFormattedDate] = react_1.useState(helpers_1.formatDate(value, formatStr));
    react_1.useEffect(() => {
        const newFormattedDate = helpers_1.formatDate(value, formatStr);
        setFormattedDate(newFormattedDate);
    }, [value, formatStr]);
    return (react_1.default.createElement("span", Object.assign({}, helpers_1.usePrimitiveProps(props)),
        prefix || null,
        formattedDate));
};
exports.default = withJourney_1.default('j-date-format', DateFormat);
